"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledGridRow = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: 1;\n"])));
var StyledGridColumn = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: auto 0px;\n  gap: 10px;\n"])));
var Slider = function Slider(_ref) {
  var min = _ref.min,
    max = _ref.max,
    step = _ref.step,
    labels = _ref.labels,
    value = _ref.value,
    icon = _ref.icon,
    onChangeValue = _ref.onChangeValue,
    title = _ref.title,
    _ref$idPrefix = _ref.idPrefix,
    idPrefix = _ref$idPrefix === void 0 ? '' : _ref$idPrefix;
  var inputLabels = {};
  labels.forEach(function (element) {
    inputLabels[element.value] = element.label;
  });
  return /*#__PURE__*/_react.default.createElement(StyledGridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    elevation: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    marginBottom: 6,
    marginTop: 0
  }, /*#__PURE__*/_react.default.createElement(StyledGridColumn, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
    name: icon,
    group: "midLight",
    size: 1
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    weight: 3
  }, title))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(StyledGridColumn, {
    col: 10
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.RangeSlider, {
    id: "".concat(idPrefix, "range-slider"),
    min: min,
    max: max,
    increment: step,
    value: value,
    onChange: onChangeValue,
    showDots: false,
    rangeLabels: inputLabels,
    appearance: "secondary",
    srLabel: {
      mainLabel: title
    }
  }))))));
};
var _default = Slider;
exports.default = _default;